module.exports = __webpack_public_path__ + "static/media/subscription3.a12c80f1.png";